import * as THREE from "three";
import { extend, useFrame } from "@react-three/fiber";
import { calcPosFromAngles, shaderMaterial } from "@react-three/drei";
import { skyFragmentShader, skyVertexShader } from "./data/shaders";
import { useControls } from "leva";
import weatherPresets from "./config/WeatherStates.json";
import { useRef } from "react";

const SkyShaderMaterial = new shaderMaterial(
  // Uniforms
  {
    luminance: 1.0,
    turbidity: 1.0,
    rayleigh: 1.0,
    mieCoefficient: 1.0,
    mieDirectionalG: 1.0,
    sunPosition: new THREE.Vector3(),
    refractiveIndex: 1.0003,
    numMolecules: 2.542e25,
    depolarizationFactor: 1.0,
    primaries: new THREE.Vector3(),
    mieKCoefficient: new THREE.Vector3(),
    mieV: 4.0,
    rayleighZenithLength: 8.4e3,
    mieZenithLength: 1.25e3,
    sunIntensityFactor: 1.0,
    sunIntensityFalloffSteepness: 1.5,
    sunAngularDiameterDegrees: 0.0093333,
    tonemapWeighting: 9.5,
    fogDensity: 0.00025,
    fogColor: new THREE.Color("#ffffff"),
  },
  // Vertex Shader
  skyVertexShader,
  // Fragment Shader
  skyFragmentShader
);

extend({ SkyShaderMaterial });

// Loads the skybox texture and applies it to the scene.
function SkyBox({ sunPosition, skyState }) {
  // scene state variables

  const options = [
    "dawn",
    "sunrise",
    "morning",
    "noon",
    "afternoon",
    "dusk",
    "night",
  ];

  var i = 1;
  var sunPos = new THREE.Vector3();

  const ref = useRef();

  useFrame((state) => {
    // const time = state.clock.getElapsedTime();
    // i = Math.floor((0.3 * time) % 7);
    // skyState = weatherPresets["skyState"][options[i]];
    // sunPosition = calcPosFromAngles(skyState.inclination, skyState.azimuth);
    // sunPosition.normalize();
    // sunPosition.multiplyScalar(10);
    // ref.current.uniforms.sunIntensityFactor.value = skyState.sunIntensityFactor;
    // ref.current.uniforms.rayleigh.value = skyState.rayleigh;
    // ref.current.uniforms.turbidity.value = skyState.turbidity;
    // ref.current.uniforms.mieCoefficient.value = skyState.mieCoefficient;
    // ref.current.uniforms.mieDirectionalG.value = skyState.mieDirectionalG;
    // sunPos.lerpVectors(
    //   ref.current.uniforms.sunPosition.value,
    //   sunPosition,
    //   0.01
    // );
    // // console.log(ref.current.uniforms.sunPosition);
    // ref.current.uniforms.sunPosition.value = sunPos;
  });

  return (
    <mesh scale={1000}>
      <boxBufferGeometry />
      <skyShaderMaterial
        ref={ref}
        fog
        side={THREE.BackSide}
        sunPosition={sunPosition}
        rayleigh={skyState.rayleigh}
        turbidity={skyState.turbidity}
        mieCoefficient={skyState.mieCoefficient}
        mieDirectionalG={skyState.mieDirectionalG}
        depolarizationFactor={0.035}
        primaries={new THREE.Vector3(6.8e-7, 5.5e-7, 4.5e-7)}
        mieKCoefficient={new THREE.Vector3(0.686, 0.678, 0.666)}
        sunIntensityFactor={skyState.sunIntensityFactor}
      ></skyShaderMaterial>
    </mesh>
  );
}

export default SkyBox;
